export const getPresupuestos = async (nrocli, grupo) => {
    try {
      const idempresa= process.env.REACT_APP_DB_EMPRESA;
    //   console.log(idempresa);
        // console.log(`${process.env.REACT_APP_APIUSER}`);
      const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/getPresupuestos/${idempresa}/${nrocli}/${grupo}`, {
        method: "GET",
        headers: {
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        //   'Authorization': 'Basic ' + btoa(`${process.env.REACT_APP_APIUSER}:${process.env.REACT_APP_APIPASS}`),
          'Content-Type': 'application/json'
        }
      });
  
      // Manejo de errores en la respuesta HTTP
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }
  
      // Parseo de la respuesta
      const data = await response.json();
      return data; // Retornamos los datos para que puedan ser utilizados por quien llame a la función
  
    } catch (error) {
      // console.error("Error en la solicitud forget:", error.message);
      throw error; // Relanzamos el error para que pueda ser manejado externamente
    }
  };
  
  export const getPedidos = async (nrocli, grupo) => {
    try {
      const idempresa= process.env.REACT_APP_DB_EMPRESA;
    //   console.log(idempresa);
        // console.log(`${process.env.REACT_APP_APIUSER}`);
      const response = await fetch(`${process.env.REACT_APP_URL_APIHN24}/getPedidos/${idempresa}/${nrocli}/${grupo}`, {
        method: "GET",
        headers: {
          'Authorization': 'Basic ' + btoa('hinetService:99RHinet202'),
        //   'Authorization': 'Basic ' + btoa(`${process.env.REACT_APP_APIUSER}:${process.env.REACT_APP_APIPASS}`),
          'Content-Type': 'application/json'
        },
      });
  
      // Manejo de errores en la respuesta HTTP
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error en la solicitud");
      }
  
      // Parseo de la respuesta
      const data = await response.json();
      return data; // Retornamos los datos para que puedan ser utilizados por quien llame a la función
  
    } catch (error) {
      // console.error("Error en la solicitud forget:", error.message);
      throw error; // Relanzamos el error para que pueda ser manejado externamente
    }
  };